import { rankingItems } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1120px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-3">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            热播榜单
          </h2>
          <span className="text-xs text-foreground-400 whitespace-nowrap">实时更新 · 热度排行</span>
        </div>
        <p className="text-sm text-foreground-500 mb-10">
          基于全网热度与用户评分综合排序，国产好剧一榜打尽
        </p>

        <div className="space-y-4">
          {rankingItems.map((item) => (
            <div
              key={item.id}
              className="flex items-center gap-4 p-4 rounded-xl bg-background-50 border border-background-200 hover:border-primary-200 transition-colors group cursor-pointer"
            >
              <div className={`flex-shrink-0 w-10 h-10 rounded-lg flex items-center justify-center font-heading font-bold text-lg ${
                item.rank === 1 ? 'bg-primary-500 text-background-50' :
                item.rank === 2 ? 'bg-accent-500 text-background-50' :
                item.rank === 3 ? 'bg-secondary-500 text-background-50' :
                'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 whitespace-nowrap group-hover:text-primary-600 transition-colors">
                    《{item.title}》
                  </h3>
                  <span className="px-2 py-0.5 rounded-md bg-background-200 text-xs text-foreground-500 whitespace-nowrap">
                    {item.category}
                  </span>
                </div>
                <p className="text-xs text-foreground-500 mt-1 line-clamp-1 hidden sm:block">
                  {item.description}
                </p>
              </div>

              <div className="flex-shrink-0 flex items-center gap-1.5">
                <span className="text-sm font-semibold text-accent-600">{item.heat}</span>
                <span className={`text-xs ${item.trend === 'up' ? 'text-primary-500' : 'text-foreground-400'}`}>
                  {item.trend === 'up' ? '↑' : '→'}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}